import React from 'react';
import { Link } from 'react-router-dom';
import CustomModalView from '../../common/input/customModal/customModalView';
import Table from 'react-bootstrap/Table';
import trash_icon from '../../assets/images/icons/user-dashboard/trash-icon.png';
import moment from 'moment';
import DOMPurify from 'dompurify';
import './FindJobStyle.scss';

import helpimg from '../../assets/images/ready-to-help.png';
import ApplyModal from './ApplyModal';

const FindJobView = (props) => {
  console.log('--CAARER-TYPE--', props.filter_carer_type);
  console.log('--CONTRACT-TYPE--', props.filter_contract_type);

  return (
    <>
      {/* cc search section open */}
      <section className="findjob-search-section">
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col-md-12 findjob-search-heading">
              <h2 className="cc-main_title--lg text-center">Find a job</h2>
            </div>
            <div className="col-md-8 findjob-search-bar">
              <div className="cc-searchbar">
                <div className="srch-fld-row">
                  <div className="srch-fld-col">
                    <input
                      onChange={(e) =>
                        props.handelSummit(
                          'search_input_postcode',
                          e.target.value
                        )
                      }
                      type="text"
                      placeholder="Postcode"
                    />
                  </div>
                  <div className="srch-fld-col">
                    <select>
                      <option>Select Profession</option>
                      <option>Doctor</option>
                    </select>
                  </div>
                  <div className="srch-fld-col srch-btn-col">
                    <input
                      onClick={(e) => props.handelSearch()}
                      type="submit"
                      value=""
                      className="form-submit-btn"
                    />
                  </div>
                </div>
              </div>
              <h5 className="job-search-info">
                List of Jobs will apear based on the postcode given by user
              </h5>
            </div>
          </div>
        </div>
      </section>
      {/* cc search section closed */}
      {/* jobs wrapper start */}
      <section className="jobs-wrapper common-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <h3>Filter Option</h3>
              <div className="filter-box">
                <h4>Contract Types</h4>
                {props.contract_type.map((contract_type, index) => (
                  <div style={{ width: '100%' }}>
                    <input
                      name="contract_type"
                      className="contract-input"
                      type="radio"
                      style={{ marginRight: '17px' }}
                      onClick={(e) =>
                        props.handelSummit(
                          'contract_type',
                          e.target.value,
                          e.target.checked
                        )
                      }
                      value={contract_type.id}
                    />
                    <label htmlFor="customCheck1">{contract_type.type}</label>
                    {contract_type.count ? (
                      <div className="badge">{contract_type.count}</div>
                    ) : (
                      <div className="badge">0</div>
                    )}
                  </div>
                ))}
              </div>
              <div className="filter-box">
                <h4>Carer Type</h4>
                {props.carer_type.map((carer_type, index) => (
                  <div style={{ width: '100%' }}>
                    <input
                      name="carer_type"
                      className="carer_type-input"
                      type="radio"
                      style={{ marginRight: '17px' }}
                      onClick={(e) =>
                        props.handelSummit(
                          'carer_type',
                          e.target.value,
                          e.target.checked
                        )
                      }
                      value={carer_type.id}
                    />
                    <label htmlFor="customCheck3">{carer_type.type}</label>
                    {carer_type.count ? (
                      <div className="badge">{carer_type.count}</div>
                    ) : (
                      <div className="badge">0</div>
                    )}
                  </div>
                ))}
              </div>
              <div className="filter-box">
                <h4>Qualification</h4>

                <div className="mCustomScrollbar" data-mcs-theme="dark">
                  {props.qualification.map((qualification, index) => (
                    <div style={{ width: '100%' }}>
                      <input
                        className="qualification_type-input"
                        name="qualification"
                        type="radio"
                        style={{ marginRight: '17px' }}
                        onClick={(e) =>
                          props.handelSummit(
                            'qualification',
                            e.target.value,
                            e.target.checked
                          )
                        }
                        value={qualification.type}
                      />
                      <label htmlFor="customCheck5">{qualification.type}</label>
                      {qualification.count ? (
                        <div className="badge">{qualification.count}</div>
                      ) : (
                        <div className="badge">0</div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="jobs-header">
                <div className="row">
                  <div className="col-lg-6 d-sm-none d-lg-block">
                    <h5>Total Jobs {props.length}</h5>
                    <div className="list-view">
                      {props.list_active === 'active' ? (
                        <a
                          href=""
                          onClick={props.handelFormat}
                          className="active"
                        >
                          <i className="fa fa-bars"></i>
                        </a>
                      ) : (
                        <a href="" onClick={props.handelFormat}>
                          <i className="fa fa-bars"></i>
                        </a>
                      )}
                      {props.list_active !== 'active' ? (
                        <a
                          href=""
                          onClick={props.handelFormat}
                          className="active"
                        >
                          <i className="fa fa-th-large"></i>
                        </a>
                      ) : (
                        <a href="" onClick={props.handelFormat}>
                          <i className="fa fa-th-large"></i>
                        </a>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-12 pad-left-0 d-sm-none d-lg-block">
                    <select className="select">
                      <option>View of Job</option>
                      <option>Popular Job 1</option>
                      <option>Popular Job 2</option>
                      <option>Popular Job 3</option>
                    </select>
                  </div>
                  <div className="col-lg-3 col-sm-12 pad-left-0 d-sm-none d-lg-block">
                    <select className="select">
                      <option>Sorting by</option>
                      <option>Popular Job 1</option>
                      <option>Popular Job 2</option>
                      <option>Popular Job 3</option>
                    </select>
                  </div>
                </div>
              </div>
              {props.card ? (
                props.jobs.map((jobs, index) => (
                  <div className="job-box">
                    <a
                      href=""
                      onClick={(e) => props.handelcompression(jobs.id)}
                      className="job-expand active"
                      data-id="job-1"
                    ></a>
                    <h2>{jobs.title}</h2>

                    <div
                      className="jobs-details"
                      style={
                        props.expand_id === jobs.id
                          ? { display: props.expand }
                          : { display: 'none' }
                      }
                      id="job-1"
                    >
                      <div className="job-requirement">
                        <div className="row">
                          <div className="col-sm-3">Job ID:</div>
                          <div className="col-sm-9">
                            <strong>{jobs.job_number}</strong>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-3">PostCode:</div>
                          <div className="col-sm-9">
                            <strong>{jobs.postcode}</strong>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-3">Requirement:</div>
                          <div className="col-sm-9">
                            <strong>{jobs.carer_type}</strong>
                          </div>
                        </div>

                        {jobs.shifts.map((shifts, index) => (
                          <>
                            <div className="row">
                              <div className="col-sm-3">Shift Start's :</div>
                              <div className="col-sm-9">
                                <strong>{shifts.start_string}</strong>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-3">End Start's:</div>
                              <div className="col-sm-9">
                                <strong>{shifts.end_string}</strong>
                              </div>
                            </div>
                          </>
                        ))}

                        <div className="row">
                          <div className="col-sm-3">Qualification:</div>
                          <div className="col-sm-9">
                            <strong>
                              {props.return_string_data(jobs.qualification)}
                            </strong>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-3">Experience:</div>
                          <div className="col-sm-9">
                            <strong>{jobs.experience_type}</strong>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-3">Language:</div>
                          <div className="col-sm-9">
                            <strong>{jobs.language_name}</strong>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-3">Remuneration:</div>
                          <div className="col-sm-9">
                            <strong>{jobs.renumerate}</strong>
                          </div>
                        </div>
                      </div>
                      <div className="job-description">
                        <h4>Job description</h4>
                        <p>
                          <span
                            className="more"
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(jobs.description),
                            }}
                          ></span>
                        </p>
                      </div>
                    </div>
                    <div className="job-date">
                      <span>
                        Start Date:{' '}
                        {jobs.shifts[0] != undefined
                          ? moment(jobs.shifts[0].start_date).format(
                              'DD-MM-YYYY'
                            )
                          : ' -- '}
                      </span>
                    </div>
                    <div className="job-view">
                      <ul>
                        <li>
                          <i className="fa fa-eye"></i> Views{' '}
                          <span>{jobs.views}</span>{' '}
                        </li>
                        <li>
                          <i className="fa fa-wpforms"></i> Applications{' '}
                          <span>{jobs.application_count}</span>{' '}
                        </li>
                        <li>
                          <i className="fa fa-calendar"></i> Closing Date{' '}
                          <span>
                            {moment(jobs.close_date).format('MMMM DD/YYYY')}
                          </span>{' '}
                        </li>
                      </ul>
                    </div>
                    <div className="job-btn">
                      <a
                        to={'/job-details/' + jobs.id}
                        className="btn-white"
                      >
                        Read More <i className="fa fa-angle-down"></i>
                      </a>

                      <a
                        href=""
                        className="btn-white"
                        onClick={(e) =>
                          props.applyShowCustomModalFavorite(jobs.id)
                        }
                      >
                        Add to Favourite
                      </a>

                      {props.today_date >
                      props.jobs[index].close_date ? null : (
                        <a
                          href=""
                          onClick={(e) => props.applyShowCustomModal(jobs.id)}
                          className="btn-red"
                        >
                          APPLY JOB <i className="fa fa-arrow-right"></i>
                        </a>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="table-area applied-job-tadble">
                  {Object.keys(props.jobs).length > 0 ? (
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Apply by</th>
                          <th>Title</th>
                          <th>Job Type</th>
                          <th>Shift Number</th>
                          <th>PostCode</th>
                          <th>Qualification</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                        {/* Apply By, Title, Job Type, Shift Number, Post Code, Qualifications, Status, Action */}
                      </thead>
                      <tbody>
                        {props.jobs.map((jobs, index) => (
                          <tr>
                            <td>{jobs.close_date}</td>
                            <td>{jobs.title}</td>
                            <td>{jobs.contracttype}</td>
                            <td>{jobs.job_number}</td>
                            <td>{jobs.postcode}</td>
                            <td>
                              {props.return_string_data(jobs.qualification)}
                            </td>
                            <td>{jobs.status}</td>
                            <td>
                              <a
                                onClick={(e) => props.declineJobModal(jobs.id)}
                                className="del_btn"
                              >
                                <img src={trash_icon} />
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : null}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="cc-help_img">
          <img src={helpimg} alt="ready to help image" />
        </div>
      </section>
      {/* jobs wrapper end */}
      <CustomModalView
        modal_show={props.modal_show}
        authResponse={props.authResponse}
        showCustomModal={props.showCustomModal}
        hideCustomModal={props.hideCustomModal}
      />
      <ApplyModal
        apply_modal_show={props.apply_modal_show}
        applyHideCustomModal={props.applyHideCustomModal}
        applyjob={props.applyjob}
        shift_select_timing={props.shift_select_timing}
        handelShift={props.handelShift}
        applied_shift_id={props.applied_shift_id}
        apply_job_check={props.apply_job_check}
        applyfavorite={props.applyfavorite}
      />
    </>
  );
};

export default FindJobView;
